/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m25.815 5.0002c2.859 0 5.185 2.378 5.185 5.3v11.4c0 2.922-2.326 5.3-5.185 5.3h-19.63c-2.859 0-5.185-2.378-5.185-5.3v-11.4c0-2.922 2.326-5.3 5.185-5.3zm3.185 16.7v-11.4c0-1.82-1.429-3.3-3.185-3.3h-19.63c-1.756 0-3.185 1.48-3.185 3.3v11.4c0 1.819 1.429 3.3 3.185 3.3h19.63c1.756 0 3.185-1.481 3.185-3.3zm-8.1986223-6.2651883c.2464964.1647673.3956223.4468417.3956223.7486165 0 .3008794-.1491259.5820583-.3956223.747721l-7.2282218 4.8480975c-.1464943.0985022-.3140417.1477533-.4815891.1477533-.1438626 0-.2868481-.035819-.4166754-.1083524-.2842164-.1558125-.4605359-.4584828-.4605359-.7871218v-9.6961951c0-.3286391.1763195-.6313094.4605359-.7871219.2833393-.156708.6280834-.1432759.8973873.0385054zm-6.8325995 3.9365048 4.7527313-3.1878883-4.7527313-3.1878883z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;